export interface AccreditedSearchResponse {
  full_name: string;
  CertificateName: string;
  serial_number: string;
  examination_date: string;
  examination_expiration_date: string;
}

export interface AccreditedSearchBody {
  expirtydate?: string;
  dob?: string;
  id?: string;
  serialNumber?: string;
}

const apiUrl = "https://dotmedica.com/patients/accreditedSearch/";

export const fetchAccreditedCertificates = async (
  body: AccreditedSearchBody
): Promise<AccreditedSearchResponse[]> => {
  try {
    // Create a FormData object
    const formData = new FormData();

    // Append the fields from the body object to the FormData instance
    if (body.expirtydate) {
      formData.append("expirtydate", body.expirtydate);
    }

    if (body.dob) {
      formData.append("dob", body.dob);
    }

    if (body.id) {
      formData.append("id", body.id);
    }
    if (body.serialNumber) {
      formData.append("serialNumber", body.serialNumber);
    }
    // Prepare headers
    const headers = new Headers();
    // No need to set Content-Type for FormData (it’s automatically set)

    // Prepare request options
    const requestOptions: RequestInit = {
      method: "POST",
      headers: headers,
      body: formData, // Use FormData as the body
    };

    // Fetch API call
    const response = await fetch(apiUrl, requestOptions);

    // Error handling for HTTP status
    if (!response.ok) {
      const errorMessage = `Status: ${response.status} ${response.statusText}`;
      console.error(errorMessage);  // Log the error message for debugging
      throw new Error(errorMessage);
    }

    // Parse and return the response
    const data: AccreditedSearchResponse[] = await response.json();
    return data;
  } catch (error: any) {
    console.error("Error fetching accredited certificates:", error);

    // Throw a new error with more details
    throw new Error(`Unable to fetch certificates: ${error.message || error}`);
  }
};
